// extracted by mini-css-extract-plugin
var _1 = "PurchaseAmountStyle-module__details___BAPRH";
var _2 = "PurchaseAmountStyle-module__details-fee___jy9wa";
var _3 = "PurchaseAmountStyle-module__details-fee___jy9wa";
var _4 = "PurchaseAmountStyle-module__purchase-amount-flex___Wsb1I";
var _5 = "PurchaseAmountStyle-module__purchase-amount-flex-one-row___kCZS2";
var _6 = "PurchaseAmountStyle-module__purchase-amount-input-wrapper___n8spL";
var _7 = "PurchaseAmountStyle-module__purchase-amount-max-limit___xSPEz";
var _8 = "PurchaseAmountStyle-module__purchase-amount-flex___Wsb1I";
var _9 = "PurchaseAmountStyle-module__purchase-amount-flex-one-row___kCZS2";
var _a = "PurchaseAmountStyle-module__purchase-amount-input-wrapper___n8spL";
var _b = "PurchaseAmountStyle-module__purchase-amount-max-limit___xSPEz";
export { _1 as "details", _2 as "details-fee", _3 as "detailsFee", _4 as "purchase-amount-flex", _5 as "purchase-amount-flex-one-row", _6 as "purchase-amount-input-wrapper", _7 as "purchase-amount-max-limit", _8 as "purchaseAmountFlex", _9 as "purchaseAmountFlexOneRow", _a as "purchaseAmountInputWrapper", _b as "purchaseAmountMaxLimit" }
